import { equals } from '@/domain/utils/DataParsers';

const truthy = equals([true, 1, '1', 'true']);

export { truthy };
